import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import CourseBanner from "../components/CourseBanner";


const HomeInterior = () => {
  const { pathname } = useLocation();
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const { hash } = location;
    if (hash) {
      const element = document.getElementById(hash.replace("#", ""));
      if (element) element.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  const office = [
    {
      id: 1,
      title: "Living Room Design",
      img:"./images/office/home/Living-room.jpg"
    },
    {
      id: 2,
      title: "Bedroom Interiors",
      img:"./images/office/home/Bedroom.jpg"
    },
    {
      id: 3,
      title: "Modular Kitchens",
      img:"./images/office/home/Kitchen.jpg"
    },
    {
      id: 4,
      title: "Dining Areas",
      img:"./images/office/home/Dining-area.jpg"
    },
    {
      id: 5,
      title: "Kids’ Rooms",
      img:"./images/office/home/Kids-room.jpg"
    },
    {
      id: 6,
      title: "Home Offices",
      img:"./images/office/home/Home-office.jpg"
    }
   

  ]
  const chair = [
    {
      id: 1,
      title: "Office Chairs",
      img:"./images/office/office/office-chairs.jpg"
    },
    {
      id: 2,
      title: "Office Tables",
      img:"./images/office/office/office-tables.jpg"
    },
    {
      id: 3,
      title: "Conference Tables",
      img:"./images/office/office/Conference-table.jpg"
    },
    {
      id: 4,
      title: "Discussion Table",
      img:"./images/office/office/Discussion-Table.jpg"
    },
    {
      id: 5,
      title: "Desking Series",
      img:"./images/office/office/Desking-Series.jpg"
    },
    {
      id: 6,
      title: "Reception Desk",
      img:"./images/office/office/HomeReception-Desk.jpg"
    }
   

  ]

  
  const storage = [
    {
      id: 1,
      title: "Compactor",
      img:"./images/office/Compactor-img.jpg"
    },
    {
      id: 2,
      title: "Filing Cabinets",
      img:"./images/office/Filing-Cabinets-img.jpg"
    },
    {
      id: 3,
      title: "Steel Almir",
      img:"./images/office/Steel-Almirah-img.jpg"
    },
    {
      id: 4,
      title: "Steel Library",
      img:"./images/office/Steel-Library-img.jpg"
    },
   

  ]
  const restaurents = [
    {
      id: 1,
      title: "Cafe Chairs",
      img:"./images/office/Cafe-Chairs-img.jpg"
    },
    {
      id: 2,
      title: "Cafe Stools",
      img:"./images/office/Cafe-Stools-img.jpg"
    },
    {
      id: 3,
      title: "Cafe Tables",
      img:"./images/office/Cafe-Tables.jpg"
    },
    
   

  ]
  const bannerData = {
    image: "/images/office/office/Furniture-Banner.jpg",
    heading: "Stylish Furniture for Every Space",
    para: "Customizable furniture solutions for homes and offices that combine style and functionality.",
  };
  return (
    <div className="page-content">
      <Helmet>
        <title>Services</title>
        <meta
          name="description"
          content="
        and innovation."
        />
        <link rel="canonical" href="https://steamvarsity.com/about-us" />
      </Helmet>
      <CourseBanner {...bannerData} />
      <section className="bg-dark service-wrapper" id="">
        <div className="container py-5">
          <div className="row">
            <div className="col-md-4">
              <div className="wrapper">
                <div className="icon-box me-4">
                  <img src="./images/office/stand.png" alt="" />
                </div>
                <div className="content">
                  <h3 className="h5">Office Furniture</h3>
                  <p>
                  Ergonomic and stylish solutions crafted to enhance workplace comfort and productivity.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="wrapper">
                <div className="icon-box me-4">
                  
                </div>
                <div className="content">
                  <h3 className="h5">Home Furniture</h3>
                  <p>
                  Elegant and functional designs to transform your living spaces into cozy havens.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="wrapper">
                <div className="icon-box me-4">
                 
                </div>
                <div className="content">
                  <h3 className="h5">Custome Furnitures</h3>
                  <p>
                  Tailored creations that perfectly match your unique style and needs.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="service2">
        <div className="container py-5">
          <div className="row">
            <div className="col-md-6">
              <div className="wrapper">
                <h2> What We Offer for Your Home</h2>

                <p>
                Explore our wide range of home interior design solutions:
                </p>
                <ul>
                  <li><b>Living Rooms:</b> "Elegant, inviting spaces perfect for relaxing and entertaining.</li>
                  <li><b>Bedrooms: </b>"Cozy sanctuaries tailored for ultimate comfort and style.</li>
                  <li><b>Modular Kitchens: </b>"Smart, functional, and stunning kitchens that make cooking a pleasur</li>
                  <li><b>Dining Areas: </b>"Stylish setups for sharing meals and creating memories.</li>
                  <li><b>Kids’ Rooms: </b>"Playful, vibrant designs that inspire imagination and creativity.</li>
                  <li><b>Home Offices: </b>"Ergonomic and inspiring spaces to boost productivity.</li>
                </ul>
              </div>
            </div>
            <div className="col-md-1"></div>
            <div className="col-md-5">
              <div className="img-wrapper ">
                <img
                  className="rounded"
                  src="/images/office/office/Furniture-Banner2.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="product-wrapper py-5 bg2">
        <div className="container">
        <div className="heading text-center pb-4">
      <h2>Home Furniture</h2>
      <p> At Integrated Interior, we redefine how you experience your living spaces. From functional layouts to breathtaking designs, we aim to turn your home into an extension of your personality.</p>
      </div>
          <div className="row">
            {office.map((item)=>{
              return(<div className="col-lg-4 col-md-6 mb-4" key={item.id}>
              <div className="wrapper position-relative">
                <div className="img-box ">
                  <img src={item.img} alt="" />
                </div>
                <div className="text">
                  <h3 className="h5"> {item.title}</h3>
                </div>
              </div>
            </div>)
            })}
            
          </div>
        </div>
      </section>
      <section className="product-wrapper py-5 bg2">
        <div className="container">
        <div className="heading text-center pb-4">
      <h2>Office Furniture</h2>
      <p> Modern and ergonomic office furniture designed to elevate your workspace with style and functionality.</p>
      </div>
          <div className="row">
            {chair.map((item)=>{
              return(<div className="col-lg-4 col-md-6 mb-4" key={item.id}>
              <div className="wrapper position-relative">
                <div className="img-box ">
                  <img src={item.img} alt="" />
                </div>
                <div className="text">
                  <h3 className="h5"> {item.title}</h3>
                </div>
              </div>
            </div>)
            })}
            
          </div>
        </div>
      </section>
      <section className="product-wrapper py-5 ">
        <div className="container">
        <div className="heading text-center pb-4">
      <h2>BEST QUALITY STEEL STORAGE</h2>
      <p> Durable, reliable, and built to last – experience the finest in steel storage solutions.</p>
      </div>
          <div className="row">
            {storage.map((item)=>{
              return(<div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={item.id}>
              <div className="wrapper position-relative">
                <div className="img-box ">
                  <img src={item.img} alt="" />
                </div>
                <div className="text">
                  <h3 className="h5"> {item.title}</h3>
                </div>
              </div>
            </div>)
            })}
            
          </div>
        </div>
      </section>
      <section className="product-wrapper py-5 ">
        <div className="container">
        <div className="heading text-center pb-4">
      <h2>CAFE & RESTAURANTS</h2>
      <p> Stylish, comfortable, and designed to elevate your café and restaurant spaces.</p>
      </div>
          <div className="row">
            {restaurents.map((item)=>{
              return(<div className="col-lg-4 col-md-6 mb-4" key={item.id}>
              <div className="wrapper position-relative">
                <div className="img-box ">
                  <img src={item.img} alt="" />
                </div>
                <div className="text">
                  <h3 className="h5"> {item.title}</h3>
                </div>
              </div>
            </div>)
            })}
            
          </div>
        </div>
      </section>

      <section className="bg2 py-5">
        <div className="container">
        <div className=" contact-card">
            <div className="wrapper">
            <div className="row">
                <div className="col-md-6">
                    
                        <div className="text-wrapper">
                            <h2 className="display-4 fw-bold mb-4">Connect with us</h2>

                            <p className="h4 mb-5">Good things happen when we connect.</p>
                            <a className="btn btn-black rounded-3" href="../contact-us/">Contact Us</a>

                        </div>
                   
                </div>
                <div className="col-md-6">
                    <div className="img-wrapper">
                        <img src="./images/office/customer-service.png" alt="" /> 
                    </div>
                </div>
            </div>
            </div>
        </div>
        </div>
    </section>
    </div>
  );
};

export default HomeInterior;
